<template>
  <div class="m">
    <div :class="`bubble ${message.from === 'me' ? 'me' : ''}`">
      <span v-if="message.from === 'me'" class="name">{{
        "you" | setText("Вы")
      }}</span>
      <span v-else class="name">{{ message.userable.full_name }}</span>
      <div class="files" v-if="message.media.length">
        <div v-for="media in message.media" :key="media.id">
          <a :href="media.links.original" target="_blank">
            {{ media.file_name }}
          </a>
        </div>
      </div>
      <span class="text"> {{ message.text }} </span>
      <span class="date"> {{ message.created_at | dateTimeFormat }} </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      default: null,
    },
  },
  computed: {},
  components: {},
  methods: {},
  created() {},
  data() {
    return {};
  },
};
</script>
<style lang="scss">
</style>
